/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedAtv1EnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_ATV1_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedAtv1EnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedAtv1EnabledSettingParser.decode(input).map(res => new TierAdvancedAtv1EnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedAtv1EnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedAtv1EnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedAtv1EnabledSettingParser.schema();
    }
}
